var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3086 3.14418C10.7682 3.14418 2.19652 11.5546 2.19652 21.8963C2.19665 32.2379 10.7682 40.6485 21.3079 40.6485C31.8482 40.6485 40.4192 32.238 40.4192 21.8963C40.4196 11.5546 31.8477 3.14418 21.3086 3.14418ZM21.3086 42.8039C9.56018 42.8039 0 33.4235 0 21.8963C0.000239795 10.3692 9.56002 0.98877 21.3079 0.98877C33.0561 0.98877 42.616 10.3692 42.616 21.8963C42.6161 33.4234 33.0559 42.8039 21.3086 42.8039Z",
    fill: "#D6DC40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5716 32.1432L17.0156 30.6171L25.9044 21.8962L17.0156 13.1755L18.5716 11.6494L29.0142 21.8962L18.5716 32.1432Z",
    fill: "#D6DC40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.71ba279f8bc2b3ed07d3426fde2f3707.svg";
export { ForwardRef as ReactComponent };